import React, { useState, useEffect } from "react";
import { Tooltip, Button } from "antd";
import { ReactSVG } from "react-svg";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { isEmpty } from "lodash";
import moment from "moment";
import { EditFilled } from "@ant-design/icons";

import IconHide from "../RouteChart/IconHide";
import IconLock from "../RouteChart/IconLock";
import { TIME_FORMAT_FRONTEND } from "../../constants";
import PhoneForm from "../Forms/Route/Phone";
import { getTranslation } from "../../utils/helper";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";

const defaultCountryCode = window.location.href.includes("nordicrouting.se") ? "se" : "sg";

const DriverList = ({
  routes,
  onClickLock,
  onClickHide,
  driverIdsLock,
  driverIdsHide,
  handleSubmit,
  setting,
  onClickRoute,
}) => {
  const user = useSelector(state => state.auth.user);
  const [copied, setCopied] = useState({});
  const [editDriverId, setEditDriverId] = useState("");
  const [countryCodeInit, setCountryCodeInit] = useState(defaultCountryCode);

  useEffect(() => {
    setCountryCodeInit(Cookies.get(`CountryCode-${user._id}`) || defaultCountryCode);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopied({});
    }, 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleUpdatePhone = params => {
    setEditDriverId("");
    handleSubmit(params);
  };

  const handleCancel = () => {
    console.log("handleCancel");
    setEditDriverId("");
  };

  return (
    <>
      {routes.map((route, index) => {
        const orders = route.orders;
        const driver = route.driver;
        const isLock = driverIdsLock.includes(driver._id);
        const isHide = driverIdsHide.includes(driver._id);
        const routeUrl = `${process.env.REACT_APP_URI}/${process.env.REACT_APP_ENV === "staging" ? "rr" : "r"}/${
          route.token
        }`;

        let status = route.status;
        if (isEmpty(driver.phone)) status = "MISSING";
        if (status !== "DISPATCHED") status = "WAITING";
        const statusText =
          status === "DISPATCHED"
            ? "DISPATCHED"
            : status === "WAITING"
            ? "Waiting to dispatch"
            : "Missing phone number";
        const showForm = editDriverId === driver._id;
        const phone = route.phone || driver.phone;
        return (
          <div key={index} className="tr" style={{ width: "100%" }}>
            <div className="td">
              <div className="driver-name">
                <IconLock isLock={isLock} onClickLock={() => onClickLock(driver._id)} />
                <IconHide isHide={isHide} onClickHide={() => onClickHide(driver._id)} />
                <Tooltip title={driver.name}>
                  <div className="name" onClick={() => onClickRoute(route, null)}>
                    {driver.name}
                  </div>
                </Tooltip>
              </div>
            </div>
            <div
              className="td items"
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}>
              <div className="item" style={{ width: "100px" }}>
                <Tooltip title={getTranslation(setting, "Route Plans", statusText)}>
                  <Button
                    className={`btn-info ${status}`}
                    style={{
                      background: "transparent",
                      border: "none",
                      padding: 0,
                      marginLeft: "10px",
                    }}>
                    <ReactSVG
                      className="icon"
                      style={{
                        height: "16px",
                      }}
                      src="/icons/info.svg"
                    />
                  </Button>
                </Tooltip>
              </div>
              <div className="item" style={{ width: "20%" }}>
                {orders.length * 2}
              </div>
              <div className="item" style={{ width: "25%" }}>
                <div className="editInlineForm">
                  {!showForm && (
                    <div className="text">
                      {phone} <EditFilled onClick={() => setEditDriverId(driver._id)} />
                    </div>
                  )}
                  {showForm && (
                    <PhoneForm
                      driverId={driver._id}
                      countryCodeInit={countryCodeInit}
                      phone={phone}
                      onSubmit={handleUpdatePhone}
                      onCancel={handleCancel}
                    />
                  )}
                </div>
              </div>
              <div className="item" style={{ width: "30%" }}>
                {routeUrl}
                <CopyToClipboard text={routeUrl} onCopy={() => setCopied({ [driver._id]: true })}>
                  <Button
                    className="btn-copy"
                    style={{
                      background: "transparent",
                      border: "none",
                      padding: 0,
                      marginLeft: "10px",
                    }}>
                    <ReactSVG
                      className="icon"
                      style={{
                        height: "16px",
                      }}
                      src="/icons/content-copy.svg"
                    />
                  </Button>
                </CopyToClipboard>
                {copied[driver._id] ? <span style={{ color: "var(--primary-color)" }}>Copied</span> : null}
              </div>
              <div className="item" style={{ width: "25%" }}>
                {status === "DISPATCHED" && (
                  <>
                    {getTranslation(setting, "Route Plans", "Seen by Driver at")}{" "}
                    {moment(route.updatedAt).format(TIME_FORMAT_FRONTEND)}
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default DriverList;
